<template>
  <div class="shop-order-info">
    <div class="order-state-container order-wrapper store-order">
      <div class="order-state" v-if="orderState > -1">
        <span>{{ orderStateOptions[orderState].label }}</span
        >&nbsp;
        <span>{{ orderStateOptions[orderState].labelEn }}</span>
      </div>
      <div v-if="orderState == 1" class="order-state-group primary-text">
        <span>{{ orderInfo.groupCount }}人成团 还差{{ orderInfo.count }}人可成团</span>
        <span>{{ orderInfo.groupCount }} in a pack, {{ orderInfo.count }} to go</span>
      </div>
    </div>
    <div class="order-no-content primary-text">订单编号 Order number：{{ orderNo }}</div>

    <template v-if="isPickUp">
      <div v-for="item in takeList" :key="item.id">
        <div class="order-location-container order-wrapper store-order-row">
          <!-- <div class="location-detail">
            <div class="location-title">
              配送信息 Distribution Information
            </div>
            <div class="order-location-content primary-text">
              <div class="order-location-item">配送方式 Mode of distribution：自提 Logistics and distribution</div>
            </div>
          </div> -->
          <div class="location-detail">
            <div class="location-title">
              自提信息 Receiving information
            </div>
            <div class="order-location-content primary-text">
              <div class="order-location-item">自提地址 Self-Pickup address：{{ item.takeAddress || "--" }}</div>
              <div class="order-location-item">手机号 Telephone：{{ item.takeMobile || "--" }}</div>
              <div class="order-location-item">联系人 Contact：{{ item.takeConcat || "--" }}</div>
            </div>
            <order-good :orderInfo="orderInfo" :info="item" @checkCode="checkCode"
                        @refundHandler="refundHandler"></order-good>
          </div>
        </div>
      </div>
    </template>

    <template v-if="isLogistics">
      <div class="order-location-container order-wrapper store-order-row">
        <!-- <div class="location-detail">
          <div class="location-title">
            配送信息 Distribution Information
          </div>
          <div class="order-location-content primary-text">
            <div class="order-location-item">配送方式 Mode of distribution：物流配送 Logistics and distribution</div>
            <div class="order-location-item">运单号 WAYBILL number：{{ orderInfo.mobile }}</div>
          </div>
        </div> -->
        <div class="location-detail">
          <div class="location-title">
            收货信息 Receiving information
          </div>
          <div class="order-location-content primary-text">
            <div class="order-location-item">收货人 Consignee：{{ orderInfo.userName }}</div>
            <div class="order-location-item">手机号 Telephone：{{ orderInfo.mobile }}</div>
            <div class="order-location-item">
              收货地址 Receiving address：{{
                orderInfo.isRoomEms == 1 ? orderInfo.roomName : orderInfo.consigneeAddress
              }}
            </div>
          </div>
        </div>
        <order-good :info="item" :orderInfo="orderInfo" v-for="item in emsList" :key="item.id"></order-good>
      </div>
    </template>

    <div class="order-dis-wrapper">
      <div class="order-dis-wrapper-inner">
        <div class="detailed-item primary-text" v-for="(item, index) in detailedT" :key="index">
          <div class="detailed-item-l">
            <span>{{ item.chName }}</span
            >&nbsp;
            <span>{{ item.enName }}</span>
          </div>
          <div class="detailed-item-r">
            <span v-if="item.hasSymbol">￥</span>
            <span>{{ item.val }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pay-info">
      <div class="location-detail">
        <div class="location-title">
          支付信息 Payment Information
        </div>
        <div class="order-location-content primary-text">
          <div class="order-location-item" v-for="(item, index) in paymentInformation.slice(0, 2)" :key="index">
            {{ item.chName }} {{ item.enName }}：{{ item.val }}
          </div>
        </div>
        <div class="order-location-content primary-text">
          <div class="order-location-item" v-for="(item, index) in paymentInformation.slice(2)" :key="index">
            {{ item.chName }} {{ item.enName }}：{{ item.val }}
          </div>
        </div>
      </div>
    </div>

    <div class="order-btns" v-if="btns.length">
      <template v-for="(btn, index) in btns">
        <div
            @click="handleClick(btn.funName)"
            :class="['btn-item', btn.btnType == 'normal' ? 'normal-btn' : 'primary-btn']"
            :key="index">
          <div>
            <p>{{ btn.chName }}</p>
            <p>{{ btn.enName }}</p>
          </div>
        </div>
      </template>
    </div>
    <PickUpCodeDialog
        title="提货码"
        v-if="pickUpCodeVisible"
        :detailVOList="detailVOList"
        :visible.sync="pickUpCodeVisible"
    />
    <ShareDialog title="" v-if="shareVisible" :visible.sync="shareVisible" :shareImg="shareImg"/>
  </div>
</template>

<script>
import OrderGood from "@/views/myProfile/order/components/OrderGood.vue";
import PickUpCodeDialog from "./components/PickUpCodeDialog";
import ShareDialog from "@/components/base/ShareDialog";

export default {
  name: "",
  data() {
    return {
      orderStateOptions: {},
      orderState: -1, //0待付款 1待成团 2待发货 3待收货 4已完成 5已关闭
      isZiti: true,
      information: [],
      distributionInformation: [],
      paymentInformation: [],
      detailedT: [],
      orderInfo: {},
      emsList: [],
      takeList: [],
      isPickUp: false, //自提
      isLogistics: false, //物流
      showTakeOutCode: false, //是否展示提货码弹窗
      takeType: "", //提货方式 1 物流 2 自提 3 物流 + 自提
      detailList: [], //提货码
      invoiceStatus: 1, //状态 -1 未开票  0待受理 1已开票 2已驳回
      orderId: "",
      btns: [],
      pickUpCodeVisible: false, //提货码显示隐藏
      detailVOList: [], //提货码数据
      shareVisible: false,
    };
  },
  props: {},
  computed: {
    orderNo() {
      return this.$route.query.orderNo;
    },
  },
  components: {OrderGood, PickUpCodeDialog, ShareDialog},
  mounted() {
    this.orderStateOptions = this.$_.cloneDeep(this.$optionsData.orderStateOptions);
    this.getOrderCommonDetail();
  },
  methods: {
    //查看订单详情
    async getOrderCommonDetail() {
      const params = {
        orderNo: this.orderNo,
      };
      try {
        let {data} = await this.$api.getOrderCommonDetail(params);
        let {
          payChannel,
          tradeNo,
          orderTime,
          payTime,
          copeAmount,
          goodsDecrAmount,
          platformDecrAmount,
          payAmount,
          bonusDecrAmount,
          copeScore,
        } = data.orderVO;
        if (data.emsList.length) {
          this.isLogistics = true;
        }
        if (data.takeList.length) {
          this.isPickUp = true;
        }
        this.distributionInformation = [
          {
            chName: "配送方式",
            enName: "Mode of distribution",
            val: this.isLogistics ? "物流配送 Logistics and distribution" : "自提 Self Pickup",
          },
          {
            chName: "运单号",
            enName: "WAYBILL number",
            val: "",
            hasSymbol: false,
          },
        ];
        const payWay=this.$utils.getPayWay(data.status, payChannel,payTime)
        this.paymentInformation = [
          {
            chName: "支付方式",
            enName: "Pay way",
            val: payWay,
            hidden: payChannel == null ? true : false,
          },
          {
            chName: "交易流水号",
            enName: "Trading serial number",
            val: tradeNo,
            hasSymbol: false,
            colored: false,
            hidden: tradeNo == null ? true : false,
          },
          {
            chName: "下单时间",
            enName: "Order time",
            val: orderTime,
            hasSymbol: false,
            colored: false,
          },
          {
            chName: "支付时间",
            enName: "Payment time",
            val: payTime,
            hasSymbol: false,
            colored: false,
            hidden: payTime == null ? true : false,
          },
        ].filter((v) => !v.hidden);
        this.detailedT = [
          {
            chName: "商品总价",
            enName: "Total price of goods",
            val: copeAmount,
            hasSymbol: true,
          },
          {
            chName: "配送费",
            enName: "Delivery charge",
            val: "0",
            hasSymbol: true,
          },
          {
            chName: "商品优惠",
            enName: "Merchandise discount",
            val: goodsDecrAmount,
            hasSymbol: true,
          },
          {
            chName: "平台优惠",
            enName: "Platform offers",
            val: platformDecrAmount,
            hasSymbol: true,
          },
          {
            chName: "订单总价",
            enName: "Total order price",
            val: payAmount,
            hasSymbol: true,
          },
          {
            chName: "奖励金",
            enName: "Bonus",
            val: bonusDecrAmount,
            hasSymbol: true,
          },
          {
            chName: "积分",
            enName: "Points",
            val: copeScore,
            hasSymbol: false,
          },
          {
            chName: this.$utils.getPayAmount(data.status,payTime).label,
            enName:  this.$utils.getPayAmount(data.status,payTime).labelEn,
            val: payAmount,
            hasSymbol: true,
            colored: true,
          },
        ];
        this.emsList = data.emsList;
        this.takeList = data.takeList;
        this.orderState = data.status;
        let info = data.emsList.length ? data.emsList[0] : data.takeList[0];
        this.orderInfo = data.orderVO;
        if (info.canInvoice == 1) {
          this.orderStateOptions[4].btns[0].hidden = false;
        }
        if (info.invoiceVO && info.invoiceVO.status == 1) {
          //状态 0待受理 1已开票 2已驳回
          this.orderStateOptions[4].btns[1].hidden = false;
        }
        this.orderStateOptions[4].btns = this.orderStateOptions[4].btns.filter((v) => !v.hidden);
        if (data.status == 3 && data.takeType == 0) {
          this.btns = [];
        } else {
          this.btns = this.orderStateOptions[data.status].btns || [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    //订单按钮点击事件
    handleClick(funName) {
      this[funName](this.orderInfo);
    },
    //申请退款
    refundHandler(val) {
      let id = val.orderGoodsNo;
      this.$router.push(`/my-profile/order/apply-refund/?id=${id}`);
    },
    //查看提货码
    async checkCode(val) {
      try {
        this.detailVOList = val || [];
        this.pickUpCodeVisible = true;
      } catch (error) {
        console.log(error);
      }
    },

    //取消订单
    cancelOrder(info) {
      this.$confirm("确定取消该订单？", "提示", {
        type: "warning",
        cancelButtonText: "再想想",
        confirmButtonText: "确定取消",
      })
          .then(async () => {
            try {
              await this.$api.cancelOrder({
                orderNo: info.orderNo,
              });
              this.$message.success("取消成功");
              this.getOrderCommonDetail();
            } catch (error) {
              console.log(error);
            }
          })
          .catch(() => {
          });
    },
    //去付款
    payGoods(info) {
      this.$router.push(`/home/pay-way?orderNo=${info.orderNo}&orderType=s`);
    },
    //去分享
    async toShare(info) {
      let {data} = await this.$api.createLink({
        content: JSON.stringify({groupId: info.goodsList[0] && info.goodsList[0].groupId}),
      });
      const params = {
        page: `implant/shareGroup/index`,
        scene: data?.shortLink,
      };
      try {
        let {data} = await this.$api.getQrCode(params);
        this.shareImg = data;
        this.shareVisible = true;
      } catch (error) {
        console.log(error);
      }
    },
    //进入到小程序订单详情
    async toMiniAppOrderInfo(info) {
      let {data} = await this.$api.createLink({
        content: JSON.stringify({orderNo: info.orderNo}),
      });
      const params = {
        page: `implant/orders/detail/index`,
        scene: data?.shortLink,
      };
      try {
        let {data} = await this.$api.getQrCode(params);
        this.shareImg = data;
        this.shareVisible = true;
      } catch (error) {
        console.log(error);
      }
    },

    //查看物流
    async checkLogistics({id}) {
      const params = {
        orderStoreId: id,
      };
      try {
        let {data} = await this.$api.getLogistics(params);
        this.$alert(data.emsNo, "物流单号");
      } catch (error) {
        console.log(error);
      }
    },
    //确认收货
    async confrimGet({orderNo}) {
      try {
        await this.$api.emsConfirm({
          orderNo,
        });
        this.$message.success("确认收货成功");
        this.getOrderCommonDetail();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-order-info {
  padding: 10px;
  box-sizing: border-box;
  box-sizing: border-box;

  .order-state-container {
    padding: 30px;
    background: #fcfcfc;
    margin-top: 30px;

    .order-state {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }

    .order-state-group {
      margin-top: 20px;
    }
  }

  .order-no-content {
    margin-top: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #f0f0f0;
  }

  .location-title {
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }

  .order-location-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 28px;

    .order-location-item {
      margin-left: 99px;
      margin-bottom: 20px;
      flex: none;

      &:first-child {
        margin-left: 0;
      }
    }
  }

  .location-detail {
    padding-bottom: 28px;
    // border-bottom: 1px solid #f0f0f0;
  }

  .order-dis-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 60px;

    .order-dis-wrapper-inner {
      text-align: right;

      .detailed-item {
        display: flex;
        align-items: center;
        width: 600px;
        justify-content: space-between;
        margin-bottom: 30px;

        .detailed-item-l {
          text-align: right;
          width: 500px;
        }

        .detailed-item-r {
          margin-left: auto;
        }
      }
    }
  }

  .order-btns {
    margin-top: 40px;
    display: flex;
    align-items: center;
  }

  .btn-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 144px;
    height: 40px;
    cursor: pointer;
    margin-top: 2px;

    div {
      font-size: 14px;
      font-weight: 400;
      text-align: center;
    }

    &.normal-btn {
      background: #fff;
      color: #333333;
    }

    &.primary-btn {
      background: #333333;
      color: #ffffff;
    }
  }
}
</style>
